import React from 'react';

const FloatingStrategyButton = () => {
  // Component hidden - contact founder functionality disabled
  return null;
};

export default FloatingStrategyButton;